import { useState } from 'react';
import { X, AlertCircle } from 'lucide-react';
import { useRoosterStore } from '../store/useRoosterStore.js';

export default function VakantieModal({ vakantie, onSluit }) {
  const { addVakantie, wijzigVakantie } = useRoosterStore();

  const [naam, setNaam] = useState(vakantie?.naam || '');
  const [vanDatum, setVanDatum] = useState(vakantie?.vanDatum || '');
  const [totDatum, setTotDatum] = useState(vakantie?.totDatum || '');

  // ISO-datumstrings (YYYY-MM-DD) vergelijken lexicografisch = chronologisch.
  const kanOpslaan =
    naam.trim() !== '' && vanDatum !== '' && totDatum !== '' && totDatum >= vanDatum;

  function slaOp() {
    if (!kanOpslaan) return;
    const gegevens = { naam: naam.trim(), vanDatum, totDatum };
    if (vakantie === null) {
      // addVakantie forceert zelf het id — bewust GEEN id meegeven.
      addVakantie({ ...gegevens, vast: false });
    } else {
      // vast NIET wijzigen: laat staan wat het was.
      wijzigVakantie(vakantie.id, gegevens);
    }
    onSluit();
  }

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-slate-100">
          <h2 className="text-lg font-semibold text-slate-800">
            {vakantie === null ? 'Vakantie toevoegen' : 'Vakantie bewerken'}
          </h2>
          <button onClick={onSluit} className="text-slate-400 hover:text-slate-600">
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Body */}
        <div className="p-6 space-y-5">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Naam</label>
            <input
              type="text"
              value={naam}
              onChange={e => setNaam(e.target.value)}
              placeholder="bijv. Meivakantie 2027"
              className="w-full border border-slate-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-brand-500"
            />
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Van</label>
              <input
                type="date"
                value={vanDatum}
                onChange={e => setVanDatum(e.target.value)}
                className="w-full border border-slate-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-brand-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Tot en met</label>
              <input
                type="date"
                value={totDatum}
                onChange={e => setTotDatum(e.target.value)}
                className="w-full border border-slate-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-brand-500"
              />
            </div>
          </div>

          {/* Info-banner */}
          <div className="flex items-start gap-2 bg-amber-50 border border-amber-200 rounded-xl px-4 py-3 text-xs text-amber-700">
            <AlertCircle className="w-4 h-4 shrink-0 mt-0.5" />
            <span>Let op: het wijzigen van een vakantie maakt bestaande roosters opnieuw aan.</span>
          </div>
        </div>

        {/* Footer */}
        <div className="flex gap-3 p-6 border-t border-slate-100">
          <button
            onClick={onSluit}
            className="flex-1 py-2 rounded-lg text-sm font-medium bg-slate-100 text-slate-700 hover:bg-slate-200 transition"
          >
            Annuleren
          </button>
          <button
            onClick={slaOp}
            disabled={!kanOpslaan}
            className="flex-1 py-2 rounded-lg text-sm font-semibold text-white transition disabled:opacity-40 bg-brand-700 hover:bg-brand-800"
          >
            Opslaan
          </button>
        </div>
      </div>
    </div>
  );
}
